import { render, staticRenderFns } from "./PriorAuthsTemplate.vue?vue&type=template&id=6d24475e&"
import script from "./PriorAuthsTemplate.vue?vue&type=script&lang=js&"
export * from "./PriorAuthsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PriorAuthsTemplate.vue?vue&type=style&index=0&id=6d24475e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports